import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

/**
 * Password input con botón para mostrar/ocultar.
 * Mantiene el estilo brutalist del app (border #0A0A0A, font-mono-data).
 */
export default function PasswordInput({
  value,
  onChange,
  placeholder = "••••••••",
  required = true,
  minLength,
  className = "",
  testid = "password-input",
  autoFocus = false,
}) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <input
        type={visible ? "text" : "password"}
        required={required}
        minLength={minLength}
        value={value}
        onChange={onChange}
        autoFocus={autoFocus}
        className={`w-full bg-white border border-[#0A0A0A] px-4 py-3 pr-12 font-mono-data text-sm focus:outline-none focus:ring-2 focus:ring-[#E53935] ${className}`}
        placeholder={placeholder}
        data-testid={testid}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? "Ocultar contraseña" : "Mostrar contraseña"}
        className="absolute right-0 top-0 h-full px-3 flex items-center text-[#5C5C5C] hover:text-[#E53935]"
        data-testid={`${testid}-toggle`}
        tabIndex={-1}
      >
        {visible ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
}
